import React, { useRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { UiIcon } from 'ui-components';
import { COMMA_CHARACKTERS } from 'utils/regex';
import { StyledUiInputTags } from './UiInputTags.styles';

const UiInputTags = (props) => {
  const {
    borderColor,
    backgroundColor,
    watch,
    className,
    color,
    iconColor,
    error,
    setError,
    placeHolder,
    value,
    setValue,
    name,
    clearErrors,
    'data-testid': dataTestId,
  } = props;

  const tagData = watch(name);

  const textareaRef = useRef(null);

  const commaCharacters = [',', '،', '‚', '‘', '’', '‚', '´', '‘', '’'];

  const setTagData = (data) => {
    setValue(name, data);
    clearErrors();
  };

  const removeTagData = (indexToRemove) => {
    setTagData([...tagData.filter((_, index) => index !== indexToRemove)]);
    if (setError) setError('');
  };

  const addTagData = (event) => {
    const text = event.target.value.replace(COMMA_CHARACKTERS, '').trim();
    if (text !== '') {
      setTagData([...tagData, text]);
      event.target.value = '';
      if (setError) setError('');
    }
  };

  const handleEnter = (event) => {
    // برای اینکه توی اندروید بتونیم کاما رو متوجه بشیم باید حتما از ولیو استفاده بشه بجای ایونت
    if (
      event.key === 'Enter' ||
      event.key === 'NumpadEnter' ||
      commaCharacters.some((char) => event.currentTarget.value.includes(char))
    ) {
      addTagData(event);
      setValue(value, '');
      clearErrors();
    }
    event.currentTarget.value = event.currentTarget.value.replace(
      COMMA_CHARACKTERS,
      ''
    );
  };

  const handleBackspace = (event) => {
    if (event.key === 'Backspace') {
      if (event.target.value.length === 0) removeTagData(tagData.length - 1);
    }
  };

  const handleFocus = () => {
    textareaRef.current.focus();
  };

  const handleOnChange = (e) => {
    setValue(value, e.target.value);
    if (e.target.value.length <= 0) {
      clearErrors();
    }
  };

  return (
    <StyledUiInputTags>
      <div className={classNames('tag-input', className, error && 'error')}>
        <ul
          onClick={handleFocus}
          className='tags'
          data-testid={`${dataTestId}-tags`}
        >
          {tagData?.map((tag, index) => (
            <li
              key={index}
              className='tag'
              style={{
                color: color ?? '#fff',
                backgroundColor: backgroundColor ?? '#000',
                borderColor: borderColor ?? '#E4E9EC',
              }}
              data-testid={`${dataTestId}-tag`}
            >
              <span
                className='tag-title'
                data-testid={`${dataTestId}-tag-title`}
              >
                {tag}
              </span>
              <span
                className='tag-close-icon'
                onClick={() => removeTagData(index)}
                data-testid={`${dataTestId}-tag-close`}
              >
                <UiIcon
                  icon='ri-close-line'
                  size={18}
                  color={iconColor ?? '#37AAAF'}
                />
              </span>
            </li>
          ))}
        </ul>
        <textarea
          ref={textareaRef}
          type='search'
          onKeyUp={handleEnter}
          data-testid={`${dataTestId}-input`}
          onKeyDown={handleBackspace}
          placeholder={tagData.length < 5 ? placeHolder : ''}
          value={watch(value)}
          onChange={handleOnChange}
        />
      </div>
    </StyledUiInputTags>
  );
};

UiInputTags.propTypes = {
  className: PropTypes.string,
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  color: PropTypes.string,
  placeHolder: PropTypes.string,
  iconColor: PropTypes.string,
  watch: PropTypes.func,
  setError: PropTypes.func,
  setValue: PropTypes.func,
  clearErrors: PropTypes.func,
  error: PropTypes.bool,
  value: PropTypes.string,
  name: PropTypes.string,
  'data-testid': PropTypes.string,
};

export default UiInputTags;
